const errors = {
  InvalidTextEncoding: "Invalid text encoding",
  "22P04": "Bad file formatting, foutieve seperator of veldwaardes",
  23505: "Key already exists",
  42601: "Syntax error, teveel kolommen",
};

export default errors;
